import { IState } from './FastEntry.reducer';
export interface IActions {
  [FastEntryActionTypes.setLoading]?: IState['isLoading'];
  [FastEntryActionTypes.setQuantity]?: IState['quantity'];
  [FastEntryActionTypes.setPrice]?: IState['price'];
  [FastEntryActionTypes.setProduct]?: IState['product'];
  [FastEntryActionTypes.setPackageId]?: IState['packageId'];
  [FastEntryActionTypes.setMatchType]?: IState['matchType'];
  [FastEntryActionTypes.setProductDisplay]?: IState['productDisplay'];
  [FastEntryActionTypes.setProductDescription]?: IState['productDescription'];
  [FastEntryActionTypes.setNonProductFieldsDisabled]?: IState['nonProductFieldsDisabled'];
  [FastEntryActionTypes.setPurchaseOrder]?: IState['purchaseOrder'];
  [FastEntryActionTypes.setFastLineDetails]?: IState['fastLineDetails'];
  [FastEntryActionTypes.setLastChangedField]?: IState['lastChangedField'];
  [FastEntryActionTypes.setPriceDisabled]?: IState['priceDisabled'];
  [FastEntryActionTypes.setIsInvalidProduct]?: IState['isInvalidProduct'];
  [FastEntryActionTypes.setApply]?: IState['apply'];
  [FastEntryActionTypes.setDisablePurchaseOrderLookup]?: IState['disablePurchaseOrderLookup'];
  [FastEntryActionTypes.resetToDefault]?: IState;
}

export enum FastEntryActionTypes {
  setLoading = 'setLoading',
  setQuantity = 'setQuantity',
  setPrice = 'setPrice',
  setProduct = 'setProduct',
  setPackageId = 'setPackageId',
  setMatchType = 'setMatchType',
  setProductDisplay = 'setProductDisplay',
  setProductDescription = 'setProductDescription',
  setNonProductFieldsDisabled = 'setNonProductFieldsDisabled',
  setPurchaseOrder = 'setPurchaseOrder',
  setFastLineDetails = 'setFastLineDetails',
  setLastChangedField = 'setLastChangedField',
  setPriceDisabled = 'setPriceDisabled',
  setIsInvalidProduct = 'setIsInvalidProduct',
  setApply = 'setApply',
  resetToDefault = 'resetToDefault',
  setDisablePurchaseOrderLookup = 'setDisablePurchaseOrderLookup',
}
